import { render, staticRenderFns } from "./ContactRequestIcon.vue?vue&type=template&id=132b3892&"
import script from "./ContactRequestIcon.vue?vue&type=script&lang=js&"
export * from "./ContactRequestIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132b3892')) {
      api.createRecord('132b3892', component.options)
    } else {
      api.reload('132b3892', component.options)
    }
    module.hot.accept("./ContactRequestIcon.vue?vue&type=template&id=132b3892&", function () {
      api.rerender('132b3892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ContactRequestIcon.vue"
export default component.exports